module.exports = __webpack_public_path__ + "static/media/OTHERSPECIFY.fb9e5b98.png";